import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=fd41c48c&scoped=true&"
import script from "./CardDescription.vue?vue&type=script&lang=js&"
export * from "./CardDescription.vue?vue&type=script&lang=js&"
import style0 from "./CardDescription.vue?vue&type=style&index=0&id=fd41c48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd41c48c",
  null
  
)

export default component.exports